// extracted by mini-css-extract-plugin
export default {"container":"UserAvatar_container__N1VRx","button":"UserAvatar_button__jO7ly"};